//
import { mapActions } from 'vuex'
import { ModelForm } from '@/components/reusable_components/next'

//
import DispatchRequestBatchModel from '@/models/Warehouse/WhDispatchRequestBatch'
import TranslatorService from '@/services/translator'
import fields from './fields'

//
export default {
    name: 'dispatch-requests-batch-update',
    components: {
        'model-form': ModelForm,
    },
    computed: {
        /**
         *
         */
        canSwitchEdit() {
            return (
                this.formData.can_edit ||
                this.formData.can_dispatch ||
                this.formData.can_reception
            )
        },

        /**
         *
         */
        formProps() {
            return {
                editable:
                    this.formData.can_edit &&
                    this.$can('EDIT_DISPATCH_REQUEST_BATCH'),
                fields: fields(this.formData),
                loading: this.busy,
                switchEdit:
                    this.$can('EDIT_DISPATCH_REQUEST_BATCH') &&
                    this.canSwitchEdit,
            }
        },

        /**
         *
         */
        title() {
            return `Lote de despacho #${this.$route.params.id}`
        },
    },
    data() {
        return {
            busy: false,
            formData: {},
        }
    },
    methods: {
        //
        ...mapActions('MenuesModule', ['setAppToolbarTitle']),

        //
        ...mapActions('SnackbarModalModule', [
            'resetSnackbarState',
            'setErrorSnackbar',
            'setSuccessSnackbar',
            'setWarningSnackbar',
        ]),

        /**
         *
         */
        error(error) {
            this.setErrorSnackbar(
                TranslatorService(
                    DispatchRequestBatchModel,
                    error.response.data
                )
            )
        },

        /**
         *
         */
        fetch() {
            return DispatchRequestBatchModel.modeler()
                .find(this.$route.params.id)
                .then(this.setFormData)
        },

        /**
         *
         */
        redirect() {
            this.$router.push({ name: 'dispatch-request-batch' })
        },

        /**
         *
         */
        reset() {
            this.toggleBusy().then(this.fetch)
        },

        /**
         *
         */
        setFormData(model) {
            this.busy = false
            this.formData = model.clone().reset()
        },

        /**
         *
         */
        submit() {
            return this.$refs.form
                .setWait(true)
                .then(this.toReception)
                .finally(this.$refs.form.setWait)
                .then(this.success)
                .then(this.redirect)
                .catch(this.error)
        },

        /**
         *
         */
        success() {
            return this.setSuccessSnackbar(
                'Lote de despacho recepcionado exitosamente.'
            )
        },

        /**
         *
         */
        async toggleBusy() {
            this.busy = !this.busy
        },

        /**
         *
         */
        toReception(model) {
            return model.receive().sync(model.toReception())
        },
    },
    beforeMount() {
        this.setAppToolbarTitle({ title: this.title })
    },
    mounted() {
        this.reset()
    },
    beforeRouteEnter(to, from, next) {
        next(ctx => {
            if (!ctx.$can('VIEW_DETAIL_DISPATCH_REQUEST_BATCH'))
                ctx.$router.push('/')
        })
    },
}
